import { render, staticRenderFns } from "./nicknameManage.vue?vue&type=template&id=32c03b9e"
import script from "./nicknameManage.vue?vue&type=script&lang=js"
export * from "./nicknameManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports